// DateBox.tsx
import { Box, Flex, Text } from "@mantine/core";
import dayjs from "dayjs";
import "dayjs/locale/fr";

type DateBoxProps = {
  date: string; // "YYYY-MM-DD"
  index: number;
  dateSelect: { id: number | string; isSelect: boolean };
  handleDateSelected: (key: number, date: string, price: number) => void;
  price: number | "Non disponible";
};

const DateBox = (props: DateBoxProps) => {
  dayjs.locale("fr");

  const isSelected = props.dateSelect.id === props.index && props.dateSelect.isSelect;
  const isUnavailable = props.price === "Non disponible" || Number(props.price) === 0;

  const handleClick = () => {
    if (!isUnavailable) {
      // Ici props.price est forcément un number
      props.handleDateSelected(props.index, props.date, Number(props.price));
    }
  };

  const dayLabel = dayjs(props.date).format("dddd DD"); // ex: "lundi 06"
  const priceLabel =
    typeof props.price === "number"
      ? props.price.toLocaleString("fr-FR", { maximumFractionDigits: 0 })
      : props.price;

  return (
    <Box
      role="button"
      aria-disabled={isUnavailable}
      tabIndex={isUnavailable ? -1 : 0}
      onClick={isUnavailable ? undefined : handleClick}
      onKeyDown={(e) => {
        if (!isUnavailable && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          handleClick();
        }
      }}
      sx={(theme) => ({
        padding: theme.spacing.md,
        borderRadius: theme.radius.md,
        cursor: isUnavailable ? "not-allowed" : "pointer",
        opacity: isUnavailable ? 0.6 : 1,
        backgroundColor: isSelected
          ? theme.colorScheme === "dark"
            ? theme.colors.dark[5]
            : theme.colors.gray[1]
          : theme.colors.white,
      })}
    >
      <Flex
        direction={{ base: "column", sm: "row" }}
        gap={{ base: "sm", sm: "lg" }}
        justify={{ base: "space-between", sm: "space-between" }}
        align="center"
      >
        <Text>
          <strong>{dayLabel.charAt(0).toUpperCase() + dayLabel.slice(1)}</strong>
        </Text>

        <Flex align={{ base: "center", sm: "flex-end" }} direction="column">
          {isUnavailable ? (
            <Text className={"from-price"}>Non disponible</Text>
          ) : (
            <>
              <Text className={"from-price"} sx={{ whiteSpace: "pre-line" }}>
                A partir de{"\n"}
              </Text>
              <Flex align="center" direction="row" gap="xs">
                <Text className={"price"}>{priceLabel}€</Text>
                <Text className={"from-price"}>/pers</Text>
              </Flex>
            </>
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default DateBox;
